import React, { Component } from 'react';
import Button from '../common/Button';
import { imageBasePath } from '../../constants/staticData';

class EmptyState extends Component {
    render() {
        const { image, message, button1, button2, customClass} = this.props;
        return (
            <div>
                <div className={"empty-state-holder "+customClass}>
                    <div className="empty-state-content">
                        <img src={image ? image : `${imageBasePath}/404.png`} alt="" />
                        <span>{message ? message : ''}</span>
                        {button1 && <Button customClass="loader_w" btnType="red" btnSize="lg" fontSize={15} label="Create Car Profile" />}
                        {button2 && <Button customClass="loader_r" btnType="transparent load-btn" btnSize="sm" fontSize={14} label="Load More" />}
                    </div>
                </div>
            </div>
        );
    }
}

export default EmptyState;



// WEBPACK FOOTER //
// ./src/components/EmptyState/EmptyState.jsx